<script lang="ts">
  import { appStore } from "$app/store.svelte"

  interface Props {
    course_progress: CourseProgressType
  }

  let { course_progress }: Props = $props()

  let step_content = course_progress.step_data.content
</script>

{#if step_content == "introduction"}
  <p class="text-center text-3xl text-bold">Welcome</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      Congratulations on starting the Impactful Recognitions Course. This course
      distills Marc Koehler’s 30+ years as an Officer in the US Nuclear
      Submarine and Turnaround CEO and how he implemented simple, powerful
      recognition systems to encourage people to success.
    </p>

    <p class="mt-6 text-lg">
      You will learn exactly what you need to do to implement an impactful
      recognition system at your company that keeps your people engaged, builds
      your culture, and drives your values and employee behaviors.
    </p>
    <p class="mt-6 text-lg">
      Just follow the step-by-step approach outlined in this online course to
      access all of the valuable videos, guides, instructional materials, and
      examples.
    </p>
    <p class="mt-6 text-lg text-bold">You can do this!</p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/305265550"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E3 Course"
      ></iframe>
    </div>
  </div>
{:else if step_content == "wrap_up"}
  <div class="px-12">
    <p class="text-center text-3xl text-bold">
      Congratulations on completing the Impactful Recognitions Course!
    </p>

    <p class="mt-6 text-lg">
      I hope you can clearly see how this simple, but powerful recognition
      system will strengthen your entire culture and contribute to your
      employees feeling more appreciated and connected to your company.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/306073753"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E3 Course"
      ></iframe>
    </div>
  </div>

  <div class="mx-auto w-full flex justify-center my-8">
    <a
      href="/plans/{appStore.plan.id}/courses"
      class="btn btn-rounded success btn-big">VIEW COURSE LIBRARY</a
    >
  </div>
{/if}
